"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ChevronDown = _interopRequireDefault(require("@decisiv/iconix/lib/components/ChevronDown"));

var _ChevronUp = _interopRequireDefault(require("@decisiv/iconix/lib/components/ChevronUp"));

var _find = _interopRequireDefault(require("lodash/find"));

var _get = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useUniqueId = _interopRequireDefault(require("../../utils/useUniqueId"));

var _Button = _interopRequireWildcard(require("../Button"));

var _DropdownList = _interopRequireDefault(require("../DropdownList"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _Typography = require("../Typography");

var _schema = _interopRequireDefault(require("./schema"));

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function SelectMenu(props) {
  var actions = props.actions,
      defaultSelected = props.defaultSelected,
      disabled = props.disabled,
      idProp = props.id,
      label = props.label,
      onChange = props.onChange,
      options = props.options,
      selected = props.selected,
      size = props.size,
      multiple = props.multiple,
      allSelectedLabel = props.allSelectedLabel,
      noneSelectedLabel = props.noneSelectedLabel,
      zIndex = props.zIndex;
  var translate = (0, _useTranslations.default)();
  var buttonRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(defaultSelected || (multiple ? [] : (0, _get.default)(options, '0.id'))),
      _useState2 = _slicedToArray(_useState, 2),
      selectedIds = _useState2[0],
      setSelectedIds = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      visible = _useState4[0],
      setVisible = _useState4[1];

  var ExpandedIndicator = (0, _react.useMemo)(function () {
    return function (iconProps) {
      return _react.default.createElement("span", null, visible ? _react.default.createElement(_ChevronUp.default, iconProps) : _react.default.createElement(_ChevronDown.default, iconProps));
    };
  }, [visible]);
  /**
   * If `selected` is present, the component is being controlled.
   */

  var isControlled = ('selected' in props);
  /**
   * If controlled, the value of `selected` should always override any
   * internally tracked state.
   */

  (0, _react.useEffect)(function () {
    isControlled && setSelectedIds(selected);
  }, [isControlled, selected, setSelectedIds]);
  var selectedOption = (0, _react.useMemo)(function () {
    return (0, _find.default)(options, function (_ref) {
      var id = _ref.id;
      return id === (multiple ? selectedIds[0] : selectedIds);
    });
  }, [options, multiple, selectedIds]);
  var handleOnChange = (0, _react.useCallback)(function (ids) {
    var value = multiple ? ids : ids[0]; // do not hide if is multi-select

    if (!multiple) {
      setVisible(false);
      buttonRef.current.focus();
    } // do not update internal state if component is controlled


    !isControlled && setSelectedIds(value);
    onChange && onChange(value);
  }, [isControlled, multiple, onChange]);
  var handleOnHide = (0, _react.useCallback)(function () {
    setVisible(false);
    buttonRef.current.focus();
  }, [setVisible]);
  var toggleVisible = (0, _react.useCallback)(function () {
    setVisible(!visible);
  }, [visible, setVisible]);
  var labelId = (0, _useUniqueId.default)(idProp, 'select-menu-');
  var buttonLabel = (0, _react.useMemo)(function () {
    if (multiple) {
      var selectedCount = selectedIds.length;

      switch (selectedCount) {
        case 1:
          return (0, _get.default)(selectedOption, 'label');

        case 0:
          return translate(noneSelectedLabel, 'selectMenu.allSelected');

        case options.length:
          return translate(allSelectedLabel, 'selectMenu.noneSelected');

        default:
          return translate(undefined, 'selectMenu.selectedCount', {
            count: selectedCount.toString()
          });
      }
    }

    return (0, _get.default)(selectedOption, 'label');
  }, [allSelectedLabel, multiple, noneSelectedLabel, options.length, selectedIds, selectedOption, translate]);
  return _react.default.createElement(_Flex.default, {
    alignItems: "center"
  }, _react.default.createElement(_Typography.P, {
    as: "span",
    id: labelId,
    marginRight: 1,
    shade: 1,
    size: size === 'small' ? 'small' : undefined
  }, label), _react.default.createElement(_Button.default, {
    "aria-labelledby": labelId,
    disabled: disabled,
    icon: ExpandedIndicator,
    iconPosition: "right",
    onClick: toggleVisible,
    ref: buttonRef,
    size: size,
    text: buttonLabel,
    variant: "ghost"
  }), _react.default.createElement(_DropdownList.default, {
    actions: actions,
    items: options,
    name: "select-menu-options",
    onChange: handleOnChange,
    onHide: handleOnHide,
    selectedIds: selectedIds,
    placement: "bottom-start",
    target: buttonRef,
    visible: visible,
    multiple: multiple,
    zIndex: zIndex
  }));
}

SelectMenu.propTypes = _objectSpread({}, _schema.default.propTypes, {
  actions: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.shape((0, _Button.makeButtonSchemaPropTypes)({
    id: _propTypes.default.string.isRequired
  }))), _propTypes.default.shape({
    left: _propTypes.default.arrayOf(_propTypes.default.shape((0, _Button.makeButtonSchemaPropTypes)({
      id: _propTypes.default.string.isRequired
    }))),
    right: _propTypes.default.arrayOf(_propTypes.default.shape((0, _Button.makeButtonSchemaPropTypes)({
      id: _propTypes.default.string.isRequired
    })))
  })])
});
SelectMenu.defaultProps = {
  actions: undefined
};
var _default = SelectMenu;
exports.default = _default;